import { GenericService } from './generic.service';
import { Condition } from '@/models';

export class ConditionService extends GenericService<Condition> {
  constructor() {
    super('v1/conditions');
  }
}
